import _ from 'lodash'
import {
    READ_ORDER_FROM_FORAGE,
    ORDER_RESET,
    SET_SERVER_ORDER,
    ORDER_ADD_USER,
    ORDER_REMOVE_USER,
} from './constants'
import { USERS_LOGIN_USER, USERS_FORGET_USERS, USERS_LOGOUT_USER } from '../constants'
import { add, remove } from '../helpers'

// Initial state for users in the store
const initialState = {}
// const initialState = {
//     tq: [],
//     sisi: [],
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Read the user order from forage
        case READ_ORDER_FROM_FORAGE:
            return action.payload

        // Remove users from the store
        case ORDER_RESET:
        case USERS_FORGET_USERS:
            return {}

        case SET_SERVER_ORDER: {
            const { serverId, order } = action.payload

            return {
                ...state,
                [serverId]: _.uniq(order),
            }
        }

        case USERS_LOGIN_USER: {
            const { serverId, user: { userId } } = action.payload
            return add(state, serverId, userId)
        }

        case ORDER_ADD_USER: {
            const { serverId, userId } = action.payload
            return add(state, serverId, userId)
        }

        case USERS_LOGOUT_USER:
        case ORDER_REMOVE_USER: {
            const { serverId, userId } = action.payload
            return remove(state, serverId, userId)
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/order/reducer.js